import React from 'react';

function NoMentorsFound() {
  return (
    <div className="arc-d-flex arc-flex-justify-center">
      <div className="no-mentors-found arc-text-align-c mb32">
        <img src={`${window.staticPath}img/mentorship/new/no-mentors.png`} alt="no mentors found" />
        <h6 className="arc-H200 arc-color-gray8 arc-font-weight-medium mt12">
          Welcome to
          {' '}
          {window.programDetails.name}
          <br />
          You&apos;ll see mentors here after they have joined
        </h6>
      </div>
    </div>
  );
}

export default NoMentorsFound;
